import { useEffect } from 'react';

import { registerUserChange } from '../analytics/product';
import { useAppSelector } from '../app/hooks';
import { useGetFullProfileByExpertIdQuery } from '../features/profile/model/profile';
//import amplitude from 'amplitude-js';

export function useUserChange() {
    const user = useAppSelector((state) => state.user);
    const profileData = useGetFullProfileByExpertIdQuery(user.cognitoId, { skip: !user.cognitoId });

    useEffect(() => {
        const didCompleteBasicProfile = () => {
            if (!profileData.data) {
                return 'Unknown';
            }
            return profileData.data.jobTitle && profileData.data.aboutMe && profileData.data.otherTopics?.length >= 1
                ? 'YES'
                : 'NO';
        };
        const completedBasicProfile = didCompleteBasicProfile();
        const jobTitle = profileData.data?.jobTitle || 'Unknown';

        registerUserChange(user, completedBasicProfile, jobTitle);
    }, [user, profileData]);
}
